import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "my-spinner",
    templateUrl: "./spinner.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./spinner.component.scss"]
})
export class SpinnerComponent {}
